export const FETCH_LL_UTILITY_LIST = 'FETCH_LL_UTILITY_LIST'
export const RECEIVE_LL_UTILITY_LIST = 'RECEIVE_LL_UTILITY_LIST'
export const FAILED_LL_UTILITY_LIST = 'FAILED_LL_UTILITY_LIST'
export const EDIT_LL_UTILITY = 'EDIT_LL_UTILITY'
export const DELETE_LL_UTILITY = 'DELETE_LL_UTILITY'
